import React from 'react';

export function useSmartTextBreak(text: string, separator = '/') {
  if (!text) return text;

  const segments = text.split(separator);

  return segments.map((segment, index) => (
    <React.Fragment key={index}>
      <span style={{ whiteSpace: 'nowrap' }}>{segment}</span>
      {index < segments.length - 1 && (
        <span style={{ whiteSpace: 'nowrap' }}>
          {separator}
          {'\u200B'}
        </span>
      )}
    </React.Fragment>
  ));
}
